import type { Collection } from 'state/utils/types';

import type { SecondaryPriceType, SecondaryQuotationType } from '../../productSearch';

export type RealtimeQuoteBcsProduct = {
  isin?: string;
  fileCode?: string;
  name?: string;
  denomination?: number;
  currency?: string;
  maturityDate?: string;
  quotationType?: SecondaryQuotationType;
  priceType?: SecondaryPriceType;
  traderGroup?: string;
  error: boolean;
};

export type RealtimeQuoteBcsProductMap = Collection<RealtimeQuoteBcsProduct>;

export const initialProductMap: RealtimeQuoteBcsProductMap = {};
